<template>
  <div class="card card-stats">
    <div class="card-body">
      <div class="row">
        <div class="col-5 col-md-4">
          <slot name="header">
            <div class="icon-big text-center"
                 :class="`text-${type}`">
              <i :class="icon"></i>
            </div>
          </slot>
        </div>
        <div class="col-7 col-md-8">
          <slot name="content">
            <div class="numbers">
              <p class="card-category">{{smallTitle}}</p>
              <p class="card-title" :class="resizeTitle" v-if="enableFormat === true">{{ title | decimal | comma }}</p>
              <p class="card-title" :class="resizeTitle" v-if="enableFormat === false">{{ title }}</p>
            </div>
          </slot>
        </div>
      </div>
      <div class="row" v-if="disableType === false">
        <div class="col-12 col-md-12">

          <template v-if="smallTitle !== 'Other'">
            <p class="type-parcel green">GREEN <span class="number">{{ green }}</span></p>
            <p class="type-parcel red">RED <span class="number">{{ red }}</span></p>
            <hr>
            <p class="type-parcel ready">READY <span class="number">{{ ready }}</span></p>
            <p class="type-parcel hold">HOLD <span class="number">{{ hold }}</span></p>
            <p class="type-parcel released">RELEASED <span class="number">{{ released }}</span></p>
            <p class="type-parcel noShow">No Show <span class="number">{{ noShow }}</span></p>
          </template>
          <template v-if="smallTitle === 'Other'">
            <p class="type-parcel over">Over <span class="number">{{ over }}</span></p>
            <p class="type-parcel unmanifest">Unmanifest <span class="number">{{ unmanifest }}</span></p>
            <p class="type-parcel noShow">CAT4 <span class="number">{{ catFour }}</span></p>
            <!-- <p class="type-parcel hold">No Show <span class="number">{{ noShow }}</span></p> -->

          </template>

        </div>
      </div>
    </div>
    <div class="card-footer">
      <hr/>
      <!-- <slot name="footer"></slot> -->
    </div>

  </div>
</template>
<script>
  export default {
    name: 'stats-card',
    props:{
      enableFormat: {
        type: Boolean,
        default: false
      },
      disableType: {
        type: Boolean,
        default: true
      },
      type: {
        type: String,
        description: 'Card text type (primary|info|danger|default|warning|success)'
      },
      title: {
        type: String,
        description: 'Card title'
      },
      smallTitle: {
        type: String,
        description: 'Card small title'
      },
      icon: {
        type: String,
        description: 'Card icon'
      },
      green: {
        type: Number,
      },
      red: {
        type: Number,
      },
      ready: {
        type: Number,
      },
      hold: {
        type: Number,
      },
      released: {
        type: Number
      },
      over: {
        type: Number
      },
      noShow: {
        type: Number
      },
      unmanifest: {
        type: Number
      },
      catFour: {
        type: Number
      }
    },
    computed: {
      resizeTitle () {
        let result = Number(this.title).toFixed(2)
        if (result.length > 8) {
          return 'hundred-thousand'
        } else if (result.length > 9) {
          return 'one-million'
        } else if (result.length > 10) {
          return 'ten-million'
        }
      }
    },
    filters: {
      comma: function (value) {
        if (!value) {
          return
        }
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
      decimal: function (value) {
        return Number(value).toFixed(2)
      },
    }
  }

</script>
<style scoped lang="scss">
  .card-content{
    min-height: 85px
  }
  .type-parcel {
    padding: 8px 16px;
    border-radius: 4px;
    margin: 20px 0;
    .number {
      float:right;
      font-size: 18px;
      font-weight: bold;
    }
  }
  .type-parcel.green{
    background-color: rgb(209, 241, 209);
    border-left: #21ce55 5px solid;
  }
  .type-parcel.red{
    background-color: rgb(250, 208, 208);
    border-left: #ff0000 5px solid;
  }
  .type-parcel.ready{
    background-color: rgba(204, 204, 204, 0.5);
    border-left: #000000 5px solid;
  }
  .type-parcel.hold{
    background-color: rgb(245, 233, 212);
    border-left: #ffba27 5px solid;
  }
  .type-parcel.released{
    background-color: rgb(209, 227, 250);
    border-left: #006eff 5px solid;
  }
  .type-parcel.over{
    background-color: #d1fad2;
    border-left: #43ce87 5px solid;
  }
  .type-parcel.noShow{
    background-color: #afbdb9;
    border-left: #586f80 5px solid;
  }
  .type-parcel.unmanifest{
    background-color: #c8c9e4;
    border-left: #7f95a7 5px solid;
  }
  .hundred-thousand {
    font-size: 1.8vw;
    @media screen and (max-width: 1024px) {
      font-size: 6.5vw;
    }
  }
  .one-million {
    font-size: 1.7vw;
  }
  .ten-million {
    font-size: 1.6vw;
  }
</style>
